module.exports = __webpack_public_path__ + "img/back@3x.20f6fd00.png";